if (!customElements.get('theme-back-to-top')) {
  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this._updateThreshold = this._updateThreshold.bind(this);
      this._scrollToTop = this._scrollToTop.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('.back-to-top__button');

      this._abortController = new AbortController();
      const signal = this._abortController.signal;

      this._scrollRafId = null;
      this._resizeRafId = null;
      this._initRafId = null;

      window.addEventListener('scroll', () => {
        if (this._scrollRafId) return;
        this._scrollRafId = requestAnimationFrame(() => {
          this._handleScroll();
          this._scrollRafId = null;
        });
      }, { passive: true, signal });

      window.addEventListener('resize', () => {
        if (this._resizeRafId) return;
        this._resizeRafId = requestAnimationFrame(() => {
          this._updateThreshold();
          this._handleScroll();
          this._resizeRafId = null;
        });
      }, { passive: true, signal });

      this.button?.addEventListener('click', this._scrollToTop, { signal });

      this._initRafId = requestAnimationFrame(() => {
        this._initRafId = null;
        this._updateThreshold();
        this._handleScroll();
      });
    }

    disconnectedCallback() {
      this._abortController?.abort();
      if (this._initRafId) cancelAnimationFrame(this._initRafId);
      if (this._scrollRafId) cancelAnimationFrame(this._scrollRafId);
      if (this._resizeRafId) cancelAnimationFrame(this._resizeRafId);
    }

    _updateThreshold() {
      this.threshold = parseInt(this.dataset.threshold, 10) || window.innerHeight;
    }

    _handleScroll() {
      this.classList.toggle('back-to-top--visible', window.scrollY > this.threshold);
    }

    _scrollToTop() {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    }
  }

  customElements.define('theme-back-to-top', BackToTop);
}
